import { generateColumnId } from 'modules/campaigns/modules/campaigns-reports/utils';
import * as FIELDS from '../../fields';
import { REPORT_PRESET } from '../../pickers';
import { PUSH_API_REPORT_ID } from './pushApiReportId';

const defaultColumns = [
    FIELDS.IS_ACTIVE.field,
    FIELDS.CONVERSION_STATUS.field,
    FIELDS.PUSH_API_SUB_NAME.field,
    FIELDS.PUSH_API_ENDPOINTS.field,
    FIELDS.PUSH_API_ACCOUNT_NAME.field,
    FIELDS.PUSH_API_PERFORMER.field,
    FIELDS.PUSH_API_LAST_MODIFY_ON_UPDATE_TIME.field,
    FIELDS.ACTIONS_COLUMN.field,
].map(field => generateColumnId(PUSH_API_REPORT_ID, field));

const customColumns = {
    [REPORT_PRESET.DEFAULT]: [
        FIELDS.IS_ACTIVE.field,
        FIELDS.CONVERSION_STATUS.field,
        FIELDS.PUSH_API_SUB_NAME.field,
        FIELDS.PUSH_API_ENDPOINTS.field,
        FIELDS.PUSH_API_ACCOUNT_NAME.field,
        FIELDS.PUSH_API_PERFORMER.field,
        FIELDS.PUSH_API_LAST_MODIFY_ON_UPDATE_TIME.field,
        FIELDS.ACTIONS_COLUMN.field,
    ].map(field => generateColumnId(PUSH_API_REPORT_ID, field)),
};

export { defaultColumns, customColumns };
